/*
 * Сравнение двух стилей бок о бок (docs/release-2026-09-19.md §5.4). Пузыри — глобальные
 * `.tgzone`/`.tg` панели превью, чип и пилюли — base.css; здесь только две колонки.
 *
 * Потолок — `--workspace-max`, как у экрана черновика, а не `--surface-max` дашбордов: строк
 * таблицы здесь нет, а есть два полотна рядом, и на широком экране запас идёт им в ширину.
 */

.page {
  width: 100%;
  max-width: var(--workspace-max);
  margin-inline: auto;
  flex: 1;
  min-width: 0;
  padding: var(--page-pad-y) var(--page-pad-x);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.headMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

/* Два полотна поровну. minmax(0, 1fr): длинная строка поста переносится внутри пузыря, а не
   растягивает страницу. */
.sides {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.side {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.sideHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.spacer {
  flex: 1;
}

/* Плашка отказа или «не обновилась»: текст и «Повторить» в одну строку, на узком — переносом.
   Вид — глобальный `.val`; здесь только ряд. Селектор составной (0,2,0): base.css подключается
   ПОСЛЕ модулей, и его `.val { align-items: flex-start }` при равной специфичности перебил бы. */
:global(.val).notice {
  align-items: center;
  flex-wrap: wrap;
}

.grow {
  flex: 1;
  min-width: 0;
}

/* tablet (1024): полотна встают одно под другим — A сверху, B под ним. */
@media (max-width: 1024px) {
  .sides {
    grid-template-columns: minmax(0, 1fr);
  }
}
